import React from 'react';
import { MdLocationOn, MdWork, MdAttachMoney } from 'react-icons/md';
import ButtonBlack from '../../../../components/Buttons/ButtonBlack';
import { BsFilePdfFill } from 'react-icons/bs';


const JobApplicationCard = ({ application , offer}) => {
  return (
    <>
      <div className="">
        <div className="bg-white divide-y rounded-lg border shadow mb-4 p-4">
          {/* Affichage du portfolio */}
          <div className="grid grid-flow-col sm:grid-flow-row grid-cols-3 gap-2 text-start text-sm pb-3">
            <div className="col-span-1 text-gray-600">Portfolio</div>
            <div className="col-span-2">
              <a href={application?.portfolio_url} target="_blank" rel="noopener noreferrer">
                {application?.portfolio_url}
              </a>
            </div>
          </div>

          {/* Affichage du message */}
          <div className="grid grid-flow-col sm:grid-flow-row grid-cols-3 gap-2 text-start text-sm py-3">
            <div className="col-span-1 text-gray-600">Message</div>
            <p className="col-span-2 max-w-full h-30 text-wrap">
              {application?.message}
            </p>
          </div>

          {/* Affichage de la pièce jointe */}
          <div className="grid  grid-cols-3 gap-2 text-start text-sm pt-3">
            <div className="col-span-1 text-gray-600">Pièce jointe</div>
            <div className="col-span-2">
              <div className=" flex gap-2 border rounded-xl items-center bg-primary-beige p-2  text-wrap text-ellipsis w-full overflow-hidden">
                <div className="bg-primary-green size-12 min-w-12 min-h-12 flex items-center justify-center p-2 text-primary rounded-full ">
                <svg  width="25x" height="25px" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path d="M8.94 20.74C7.45715 20.7458 6.02743 20.1882 4.94001 19.18C4.41043 18.6904 3.98787 18.0965 3.69887 17.4356C3.40987 16.7748 3.26068 16.0613 3.26068 15.34C3.26068 14.6188 3.40987 13.9053 3.69887 13.2445C3.98787 12.5836 4.41043 11.9897 4.94001 11.5L12.5 4.36005C13.2775 3.65032 14.2923 3.25684 15.345 3.25684C16.3977 3.25684 17.4125 3.65032 18.19 4.36005C18.5954 4.73639 18.9204 5.19087 19.1456 5.69612C19.3707 6.20138 19.4913 6.74697 19.5 7.30005C19.5027 7.77802 19.4064 8.25137 19.2171 8.69025C19.0278 9.12914 18.7495 9.52404 18.4 9.85005L10.83 17C10.3732 17.4239 9.77312 17.6594 9.15 17.6594C8.52689 17.6594 7.92679 17.4239 7.47001 17C7.24334 16.7912 7.06243 16.5376 6.93869 16.2554C6.81495 15.9731 6.75106 15.6682 6.75106 15.36C6.75106 15.0518 6.81495 14.747 6.93869 14.4647C7.06243 14.1824 7.24334 13.9289 7.47001 13.72L14.47 7.13005C14.6106 6.9896 14.8013 6.91071 15 6.91071C15.1988 6.91071 15.3894 6.9896 15.53 7.13005C15.6705 7.27067 15.7493 7.4613 15.7493 7.66005C15.7493 7.8588 15.6705 8.04942 15.53 8.19005L8.53 14.78C8.45149 14.8486 8.38856 14.9331 8.34544 15.028C8.30232 15.1228 8.28 15.2258 8.28 15.33C8.28 15.4343 8.30232 15.5373 8.34544 15.6321C8.38856 15.727 8.45149 15.8115 8.53 15.88C8.71114 16.035 8.94165 16.1201 9.18001 16.1201C9.41836 16.1201 9.64887 16.035 9.83001 15.88L17.4 8.75005C17.5926 8.56129 17.745 8.33553 17.8482 8.08635C17.9513 7.83717 18.0029 7.56971 18 7.30005C17.9917 6.95248 17.913 6.6102 17.7686 6.29393C17.6242 5.97767 17.4172 5.69398 17.16 5.46005C16.6663 5.0025 16.0181 4.74828 15.345 4.74828C14.6719 4.74828 14.0237 5.0025 13.53 5.46005L6.00001 12.59C5.61867 12.9395 5.31419 13.3644 5.10588 13.8378C4.89757 14.3113 4.79001 14.8228 4.79001 15.34C4.79001 15.8573 4.89757 16.3688 5.10588 16.8423C5.31419 17.3157 5.61867 17.7406 6.00001 18.09C6.81452 18.8492 7.88656 19.2714 9.00001 19.2714C10.1135 19.2714 11.1855 18.8492 12 18.09L19.49 11C19.559 10.9293 19.6414 10.8731 19.7324 10.8347C19.8234 10.7963 19.9212 10.7765 20.02 10.7765C20.1188 10.7765 20.2166 10.7963 20.3076 10.8347C20.3986 10.8731 20.4811 10.9293 20.55 11C20.6905 11.1407 20.7693 11.3313 20.7693 11.53C20.7693 11.7288 20.6905 11.9194 20.55 12.06L13 19.18C11.898 20.2034 10.4437 20.7622 8.94 20.74Z" fill="#000000"/>
                          </svg>
                </div>
                {application?.resume}
              </div>
            </div>
            
          </div>

        
        </div>

        <div className="bg-white rounded-lg shadow-md p-4 mb-4 border">
          <div className="flex justify-between items-center mb-4">
            <h2 className="text-sm font-semibold">Postes Postulés</h2>
            <a href="#" className="text-blue-600 hover:underline text-sm">Voir les détails ></a>
          </div>

          <h3 className="text-xl font-semibold mb-2">{offer?.job_title}</h3>

          <div className="flex items-center space-x-2 mb-4">
            <MdWork className="text-gray-500" />
            <span className="text-sm">CDI</span>
            <MdLocationOn className="text-gray-500" />
            <span className="text-sm">{offer?.working_method}</span>
            <MdLocationOn className="text-gray-500" />
            <span className="text-sm">Sur place</span>
          </div>

          <div className="mb-4">
            <span className="font-semibold">Durée :</span>
            <span className="text-sm">{offer?.duration}</span>
          </div>

          <div className="flex justify-between">
            <div className="text-sm">
              <span className="font-semibold">Salaire :</span>
              <span className="text-sm">{offer?.salary}</span>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

// const JobApplicationCard = ({application}) => {
//   return (
//     <>
//     <div className="bg-white divide-y rounded-lg border shadow mb-4">
//         {/* <div className="bg-slate-200 w-full px-6 py-4">
//             <ButtonBlack>Prochaine étape </ButtonBlack>
//         </div> */}
//         <div className="p-4 divide-y">
//             <div className="grid grid-flow-col sm:grid-flow-row grid-cols-3 gap-2 text-start text-sm pb-3">
//                 <div className="col-span-1  text-gray-600">
//                     Message
//                 </div>
//                 <div className="col-span-2">
//                     www.portfolio@gmail.com
//                 </div>
//             </div>
//             <div className="grid grid-flow-col sm:grid-flow-row grid-cols-3 gap-2 text-start text-sm py-3">
//             <div className="col-span-1  text-gray-600">
//                 Message
//             </div>
//             <p className="col-span-2 max-w-full h-30 text-wrap">
//                 Lorem ipsum dolor sit amet consectetur adipisicing elit. Deleniti, consequuntur rerum! Temporibus suscipit nulla eveniet perferendis, aspernatur a, 
//             </p>
//         </div>
//         <div className="grid grid-flow-col sm:grid-flow-row grid-cols-3 gap-2 text-start text-sm pt-3">
//             <div className="col-span-1  text-gray-600">
//                 Pièce jointe
//             </div>
//             <div className=" flex gap-2 border rounded-xl items-center bg-primary-beige  p-2">
//             <div className="bg-primary-green flex items-center justify-center p-2 text-primary rounded-full">
//                         <svg width="25x" height="25px" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
//                         <path d="M8.94 20.74C7.45715 20.7458 6.02743 20.1882 4.94001 19.18C4.41043 18.6904 3.98787 18.0965 3.69887 17.4356C3.40987 16.7748 3.26068 16.0613 3.26068 15.34C3.26068 14.6188 3.40987 13.9053 3.69887 13.2445C3.98787 12.5836 4.41043 11.9897 4.94001 11.5L12.5 4.36005C13.2775 3.65032 14.2923 3.25684 15.345 3.25684C16.3977 3.25684 17.4125 3.65032 18.19 4.36005C18.5954 4.73639 18.9204 5.19087 19.1456 5.69612C19.3707 6.20138 19.4913 6.74697 19.5 7.30005C19.5027 7.77802 19.4064 8.25137 19.2171 8.69025C19.0278 9.12914 18.7495 9.52404 18.4 9.85005L10.83 17C10.3732 17.4239 9.77312 17.6594 9.15 17.6594C8.52689 17.6594 7.92679 17.4239 7.47001 17C7.24334 16.7912 7.06243 16.5376 6.93869 16.2554C6.81495 15.9731 6.75106 15.6682 6.75106 15.36C6.75106 15.0518 6.81495 14.747 6.93869 14.4647C7.06243 14.1824 7.24334 13.9289 7.47001 13.72L14.47 7.13005C14.6106 6.9896 14.8013 6.91071 15 6.91071C15.1988 6.91071 15.3894 6.9896 15.53 7.13005C15.6705 7.27067 15.7493 7.4613 15.7493 7.66005C15.7493 7.8588 15.6705 8.04942 15.53 8.19005L8.53 14.78C8.45149 14.8486 8.38856 14.9331 8.34544 15.028C8.30232 15.1228 8.28 15.2258 8.28 15.33C8.28 15.4343 8.30232 15.5373 8.34544 15.6321C8.38856 15.727 8.45149 15.8115 8.53 15.88C8.71114 16.035 8.94165 16.1201 9.18001 16.1201C9.41836 16.1201 9.64887 16.035 9.83001 15.88L17.4 8.75005C17.5926 8.56129 17.745 8.33553 17.8482 8.08635C17.9513 7.83717 18.0029 7.56971 18 7.30005C17.9917 6.95248 17.913 6.6102 17.7686 6.29393C17.6242 5.97767 17.4172 5.69398 17.16 5.46005C16.6663 5.0025 16.0181 4.74828 15.345 4.74828C14.6719 4.74828 14.0237 5.0025 13.53 5.46005L6.00001 12.59C5.61867 12.9395 5.31419 13.3644 5.10588 13.8378C4.89757 14.3113 4.79001 14.8228 4.79001 15.34C4.79001 15.8573 4.89757 16.3688 5.10588 16.8423C5.31419 17.3157 5.61867 17.7406 6.00001 18.09C6.81452 18.8492 7.88656 19.2714 9.00001 19.2714C10.1135 19.2714 11.1855 18.8492 12 18.09L19.49 11C19.559 10.9293 19.6414 10.8731 19.7324 10.8347C19.8234 10.7963 19.9212 10.7765 20.02 10.7765C20.1188 10.7765 20.2166 10.7963 20.3076 10.8347C20.3986 10.8731 20.4811 10.9293 20.55 11C20.6905 11.1407 20.7693 11.3313 20.7693 11.53C20.7693 11.7288 20.6905 11.9194 20.55 12.06L13 19.18C11.898 20.2034 10.4437 20.7622 8.94 20.74Z" fill="#000000"/>
//                         </svg>
//                         </div>
//                         Piecejointe.pdf
//             </div>
//         </div>
//         </div>
       

//     </div>
//     <div className="bg-white rounded-lg shadow-md p-4 mb-4 border">
//       {/* En-tête de la carte */}
//       <div className="flex justify-between items-center mb-4">
//         <h2 className="text-sm font-semibold">Jobs Applied</h2>
//         <a href="#" className="text-blue-600 hover:underline text-sm">View details ></a>
//       </div>

//       {/* Titre du poste */}
//       <h3 className="text-xl font-semibold mb-2">Research and Development Officer</h3>

//       {/* Détails du poste (icônes et texte) */}
//       <div className="flex items-center space-x-2 mb-4">
//         <MdWork className="text-gray-500" />
//         <span className="text-sm">Fulltime</span>
//         <MdLocationOn className="text-gray-500" />
//         <span className="text-sm">Jogja</span>
//         <MdLocationOn className="text-gray-500" />
//         <span className="text-sm">Onsite</span>
//       </div>

//       {/* Séparateur */}
//       <hr className="mb-4" />

//       {/* Détails supplémentaires (grille responsive) */}
//       <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
//         {/* Expérience */}
//         <div>
//           <p className="text-sm font-medium">Experience in Years</p>
//           <p className="text-sm font-semibold">4 Years</p>
//         </div>
//         {/* Employeur actuel */}
//         <div>
//           <p className="text-sm font-medium">Current Employer</p>
//           <p className="text-sm font-semibold">Acme Studio</p>
//         </div>
//         {/* Salaire actuel */}
//         <div>
//           <p className="text-sm font-medium">Current Salary</p>
//           <p className="text-sm font-semibold">5.000.000 IDR</p>
//         </div>
//         {/* Salaire attendu */}
//         <div>
//           <p className="text-sm font-medium">Expected Salary</p>
//           <p className="text-sm font-semibold">8.000.000 IDR</p>
//         </div>
//         {/* Référence */}
//         <div>
//           <p className="text-sm font-medium">Referred by</p>
//           <p className="text-sm font-semibold">No Referral</p>
//         </div>
//       </div>
//     </div>
//     </>
//   );
// };

export default JobApplicationCard;